import { z } from 'zod';
import { SchemaTimestamp } from '@axiom/types';

export const CandidateTagSubtagSchema = z.object({
  id: z.string().uuid(),
  candidateId: z.string().uuid(),
  tagId: z.string().uuid(),
  createdAt: SchemaTimestamp,
  updatedAt: SchemaTimestamp,
});

export type CandidateTagSubtag = z.infer<typeof CandidateTagSubtagSchema>;
